import qs from "qs";

// Action Types
export const LIST = "bontempo/clothingColors/LIST";
export const LIST_SUCCESS = "bontempo/clothingColors/LIST_SUCCESS";
export const LIST_FAIL = "bontempo/clothingColors/LIST_FAIL";

export const DETAILS = "bontempo/clothingColors/DETAILS";
export const DETAILS_SUCCESS = "bontempo/clothingColors/DETAILS_SUCCESS";
export const DETAILS_FAIL = "bontempo/clothingColors/DETAILS_FAIL";

export const SAVE = "bontempo/clothingColors/SAVE";
export const SAVE_SUCCESS = "bontempo/clothingColors/SAVE_SUCCESS";
export const SAVE_FAIL = "bontempo/clothingColors/SAVE_FAIL";

export const DELETE = "bontempo/clothingColors/DELETE";
export const DELETE_SUCCESS = "bontempo/clothingColors/DELETE_SUCCESS";
export const DELETE_FAIL = "bontempo/clothingColors/DELETE_FAIL";

// Reducer
const initialState = {
  data: null,
  details: null,
  loading: false,
  module: "looks/cores",
  total: 0
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST:
      return { ...state, loading: true };
    case LIST_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    case LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case DETAILS:
      return { ...state, loading: true };
    case DETAILS_SUCCESS:
      let details = action.payload.data;

      if (details.restrictions) {
        details.restrictions = details.restrictions.map(category => {
          return category.id;
        });
      }

      return {
        ...state,
        details,
        loading: false
      };
    case DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case SAVE:
      return { ...state, loading: true };
    case SAVE_SUCCESS:
    case SAVE_FAIL:
      return { ...state, loading: false };

    case DELETE:
      return { ...state, loading: true };
    case DELETE_SUCCESS:
    case DELETE_FAIL:
      return { ...state, loading: false };

    default:
      return state;
  }
}

// Action Creators
export function get(params) {
  return {
    type: LIST,
    payload: {
      request: {
        url: `/clothing-colors?${qs.stringify(params)}`
      }
    }
  };
}

export function getDetails(id) {
  return {
    type: DETAILS,
    payload: {
      request: {
        url: `/clothing-colors/${id}`
      }
    }
  };
}

export function add(data) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/clothing-colors`,
        method: "post",
        data: data
      }
    }
  };
}

export function edit(data, id) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/clothing-colors/${id}`,
        method: "put",
        data: data
      }
    }
  };
}

export function remove(id) {
  return {
    type: DELETE,
    payload: {
      request: {
        url: `/clothing-colors/${id}`,
        method: "delete"
      }
    }
  };
}
